import forEach from 'lodash/forEach';
import { ConnectionStat } from 'app/views/view_types/network/shared/connections/connectionStat';
import { ConnectionService } from 'app/views/view_types/network/shared/connections/connection.service';

export class NextHopGraphData {
    private _connectionService: ConnectionService;

    constructor(connectionService: ConnectionService) {
        this._connectionService = connectionService;
    }

    getNextHopData(): { nodes: any[]; links: any[] } {
        let hops: ConnectionStat[] = [];
        let connectionStats = this._connectionService.getCurrentNextHopStats();

        let assetByName = {};

        forEach(connectionStats, (connectionStat) => {
            if (!connectionStat.fromAsset || !connectionStat.toAsset) {
                return;
            }
            hops.push(connectionStat);
            assetByName[connectionStat.fromAsset.name] = connectionStat.fromAsset;
            assetByName[connectionStat.toAsset.name] = connectionStat.toAsset;
        });

        let result = {
            nodes: [],
            links: [],
        };

        let nodeByName = {};

        forEach(assetByName, (asset: any, assetName) => {
            let node = {
                name: assetName,
                group: asset.typeName,
                cesiumEntity: {
                    imsAsset: asset,
                },
            };
            nodeByName[assetName] = node;
            result.nodes.push(node);
        });

        forEach(hops, (hop) => {
            result.links.push({
                source: nodeByName[hop.fromAsset.name],
                target: nodeByName[hop.toAsset.name],
                value: 1,
            });
        });

        return result;
    }
}
